Alerts = require 'views/lib/alerts'
Auth = require 'db/auth'
Browser = require 'lib/browser'
Controller = require 'controller'
getExperiment = require 'lib/experiments/simple-test'
Keyboard = require 'lib/keyboard'
l = require 'lib/localize'
template = require 'views/templates/create_first_board'
trackUe = require 'debug/trackUe'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'

module.exports = class CreateFirstBoardView extends View
  className: 'first-board-container'
  tagName: 'form'
  events:
    'click .js-submit': 'onSubmit'
    'click .js-cancel': 'onCancel'
    'click .js-continue': 'onContinue'
    'click .js-step': (e) ->
      currentStep = @getStepElements()
      targetStep = @getStepElements(@$(e.currentTarget).attr('data-step'))
      trackUe('create first board view', 'navigates', '', '', 'to new step', 'by clicking navigation dot',
        { 'currentStep': currentStep.name, 'nextStep': targetStep.name, 'stepCompleted': currentStep.isCompleted })
      @navigateToStep(targetStep)
    'keyup input': 'processInput'
    'keydown .js-continue': (e) ->
        if Keyboard.isSubmitEvent(e)
          @onContinue(e)
    'keydown .js-submit': (e) ->
        if Keyboard.isSubmitEvent(e)
          @onSubmit(e)

  initialize: ->
    @makeDebouncedMethods 'buildBoard'

  render: ->
    @$el.html(template)
    @

  getStepElements: (stepName) ->
    stepName ?= @$('.current-step').attr('data-step')
    {
      name: stepName
      class: ".#{stepName}"
      nav: @$(".first-board-navigation span[data-step=#{stepName}]")
      text: @$(".first-board-text > .#{stepName}")
      input: ".js-#{stepName}"
      display: ".js-#{stepName}-display"
      isCompleted: @$(".first-board-text .#{stepName} input:first").val()?.length > 0
      isLast: @$(".first-board-navigation span[data-step=#{stepName}]").next()?.length == 0
      boardBackground: "#{stepName}-background"
    }

  handleStep: (step) ->
    @$('.js-continue').toggleClass('is-active', step.isCompleted)
    @$('.js-submit').toggleClass('hide', !step.isLast)
    @$('.js-continue').toggleClass('hide', step.isLast)

  updateMockBoard: (step) ->
    @$(step.input).map (i, e) =>
      name = @$(e).val()
      @$(@$(step.display).get(i))
        .text(name)
        .toggleClass('is-active', name?.length > 0)
    @$('.check-name-placeholder').toggleClass('hide', (!step.isLast || @$('.js-check-name').val().length > 0))

  updateContext: ->
    @$('.js-text-with-list-name').html l('add titles for a few cards in your named list', listName: @$('.js-list-name:first').val())
    firstCardTitle = @$('.js-card-name:first').val()
    if firstCardTitle.length > 0
      @$('.js-check-title-display').text firstCardTitle
    else
      @$('.js-check-title-display').text l('untitled card')
    @$('.js-text-with-card-name').html l('start by adding a checklist item to your named card', cardName: firstCardTitle)

  displayInput: (step) ->
    @$('.first-board-image-list:nth-child(n+2)').map (i, e) =>
      @$(e).toggleClass('first-board-image-list-empty', step.name == 'card-name' || step.name == 'check-name')
    @$('.first-board-image-list:nth-child(n+2) .first-board-image-card').map (i, e) =>
      @$(e).toggleClass('hide', step.name == 'card-name' || step.name == 'check-name')

  navigateToStep: (targetStep) ->
    currentStep = @getStepElements()
    currentStep.text.addClass('hide')
    currentStep.nav.removeClass('current-step')
    @$('.first-board-image').removeClass(currentStep.boardBackground)

    isInternetExplorer = Browser.browserVersionStr.indexOf('explorer') > -1 || Browser.browserVersionStr.indexOf('edge') > -1
    targetStep.text.removeClass('hide')
    targetStep.nav.addClass('current-step')
    @$('.first-board-image').addClass(targetStep.boardBackground)
    @$('.first-board-image-base').toggleClass('hide', targetStep.isLast && isInternetExplorer)
    @$('.first-board-image-base-shadow').toggleClass('hide', !targetStep.isLast || isInternetExplorer)
    @$('.check-name-image').toggleClass('hide', !targetStep.isLast || isInternetExplorer)
    @$('.check-name-display').toggleClass('hide', !targetStep.isLast)
    @$('.check-name-display').toggleClass('mod-ie', isInternetExplorer)

    @displayInput(targetStep)
    @updateContext()
    @processInput()

  processInput: ->
    step = @getStepElements()
    @updateMockBoard(step)
    @handleStep(step)

  onContinue: (e) ->
    step = @getStepElements()
    if step.isCompleted
      nextStep = if step.isLast then @getStepElements('board-name') else @getStepElements(@$(step.nav.next()).attr('data-step'))
      trackUe('create first board view', 'navigates', '', '', 'to new step', 'by clicking on continue footer',
        { 'currentStep': step.name, 'nextStep': nextStep.name, 'stepCompleted': step.isCompleted })
      @navigateToStep(nextStep)

  getPlaceholder: (stepName) ->
    if stepName == 'list-name'
      return ['To Do', 'Doing', 'Done']
    else if stepName != 'check-name'
      return ["Untitled #{Util.capitalize(stepName.split('-')[0])}"]

  sanitizeInput: (stepName) ->
    placeholder = @getPlaceholder(stepName)
    inputs = @$(".js-#{stepName}").map (i, e) =>
      return @$(e).val()?.trim()
    sanitizedInputs = _.without inputs, ''
    if sanitizedInputs.length == 0 && placeholder? then return placeholder else return sanitizedInputs

  buildBoard: ->
    name = @sanitizeInput('board-name')[0]
    initialData = { name }
    requestData = _.extend({
      prefs_permissionLevel: 'private'
      prefs_selfJoin: true
      prefs_background: 'lime'
      creationMethod: 'assisted'
      defaultLists: false
    }, initialData)

    newBoard = Auth.me().boardList.create initialData, {
      requestData: requestData
      success: (board) =>
        # this fixes an issue with idBoards not being updated at the time that
        # the board gets rendered and the client thinking the member is not on
        # the board
        if board.id !in (currentBoards = Auth.me().get('idBoards'))
          Auth.me().set('idBoards', currentBoards.concat(board.id))
      error: =>
        Alerts.flash('could not create board', 'error', 'create error')
    }

    @listenTo @model.boardList, 'sync', =>
      listInputs = @sanitizeInput('list-name')
      newLists = @createFromInputs(listInputs, newBoard.listList)
      @listenTo newLists[0], 'sync', =>
        cardInputs = @sanitizeInput('card-name')
        newCards = @createFromInputs(cardInputs, newLists[0].cardList)
        checklistInput = @sanitizeInput('check-name')
        if _.isEmpty checklistInput
          @navigateToNewBoard(newBoard)
        else
          @listenTo newCards[0], 'sync', =>
            checklist = @createFromInputs(['Checklist'], newCards[0].checklistList, { idCard: newCards[0].id })[0]
            @listenTo checklist, 'sync', =>
              checkItem = @createFromInputs(checklistInput, checklist.checkItemList)[0]
              @listenTo checkItem, 'sync', =>
                # if we navigate before the checklist item is synced, you get this weird experience where the
                # item exists on the card, but not yet in the card preview
                @navigateToNewBoard(newBoard)

  createFromInputs: (inputs, collection, [attrs]...) ->
    return _.map inputs, (name, index) =>
      requestData = _.extend({
        name: name
        pos: index + 1
      }, attrs)
      return collection.create requestData

  onSubmit: (e) ->
    step = @getStepElements()
    trackUe('create first board view', 'creates', 'board', '', '', 'by clicking on the submit footer', { 'currentStep': step.name, 'stepCompleted': step.isCompleted })
    @buildBoardDebounced()
    @$('.js-submit').removeClass('js-submit')

  onCancel: (e) ->
    step = @getStepElements()
    trackUe('create first board view', 'creates', 'board', '', '', 'by clicking skip', { 'currentStep': step.name, 'stepCompleted': step.isCompleted })
    @buildBoardDebounced()
    @$('.js-cancel').removeClass('js-cancel')

  navigateToNewBoard: (board) ->
    Auth.me().dismiss('create-first-board')
    Controller.displayBoard({
      idBoard: board.id
      openListComposer: false
      openCardComposerInFirstList: true
    }).done()



// WEBPACK FOOTER //
// ./app/scripts/views/board/create-first-board-view.coffee